export default "__VITE_ASSET__CiXsQZQN__"